export default __webpack_public_path__ + "static/media/IMG-20250105-WA0022.25f705a2.jpg";